import { Box, Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import apis from "../../services";
import { DataGrid } from "@mui/x-data-grid";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import UsersDocumentTable from "components/datagrid/UsersDocumentTable";
import useNavigate from "hooks/Navigate";
import { Form, Col } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const PAGE_LIMIT = 20;

export const UserDocuments = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: PAGE_LIMIT,
    totalPages: 1,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPage(1);
      setSearch(searchInput.trim());
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchInput]);

  const fetchAllUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apis.getAllUser({ search, page, limit: PAGE_LIMIT });
      if (res?.data?.status) {
        setUsers(res?.data?.users || []);
        setPagination(
          res?.data?.pagination || {
            total: res?.data?.users?.length || 0,
            page,
            limit: PAGE_LIMIT,
            totalPages: 1,
          }
        );
      } else {
        toast.error(res?.data?.message || "Unable to load users");
      }
    } catch (error) {
      toast.error(error?.message || "Unable to load users");
    } finally {
      setLoading(false);
    }
  }, [page, search]);

  const approvedDocuments = async (id) => {
    const res = await apis.approvedDocumentsUser(id);
    if (res.data.status) {
      await fetchAllUsers();
      toast.success(res.data.message);
    } else toast.error(res.data.message);
  };

  const disapprovedDocuments = async (id) => {
    const shouldDisapprove = window.confirm(
      "Are you sure you want to disapprove this user's documents?"
    );

    if (!shouldDisapprove) return;

    try {
      const res = await apis.disapprovedDocumentsUser(id);
      if (res?.data?.status) {
        await fetchAllUsers();
        toast.success(res.data.message);
      } else {
        toast.error(res?.data?.message || "Unable to disapprove documents");
      }
    } catch (error) {
      toast.error(error?.message || "Unable to disapprove documents");
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, [fetchAllUsers]);

  const onPageChange = (direction) => {
    if (direction === "prev" && page === 1) return;
    if (direction === "next" && page >= pagination.totalPages) return;

    setPage((currentPage) =>
      direction === "next" ? currentPage + 1 : currentPage - 1
    );
  };

  const tables = UsersDocumentTable(users, {
    navigate,
    approvedDocuments,
    disapprovedDocuments,
    offset: (page - 1) * PAGE_LIMIT,
  });

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                // maxWidth="xl"
                sx={{ mt: 4, mb: 4 }}
                className="mainContainerComp"
              >
                <div className="flex-with-title"></div>
                <Col xs={12} md={12} lg={12} className="mt-3 p-0">
                  <Form.Group className="my-2" style={{ position: "relative" }}>
                    <Form.Label>Search by Name or Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter name or email"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                    <div className="searchCon">
                      <CiSearch
                        className="search-icon"
                        color="#AFAEAE"
                        fontSize={18}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    //checkboxSelection
                    rows={tables?.rows}
                    columns={tables?.columns}
                    hideFooter
                    pageSize={PAGE_LIMIT}
                    rowsPerPageOptions={[PAGE_LIMIT]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                  />
                </Grid>
                <div className="pagination-container">
                  <div>Total: {pagination.total}</div>
                  <div>
                    <button
                      className="paginator"
                      disabled={page === 1}
                      onClick={() => onPageChange("prev")}
                    >
                      <IoIosArrowBack />
                    </button>
                    Page {pagination.page} of {pagination.totalPages}
                    <button
                      className="paginator"
                      disabled={page >= pagination.totalPages}
                      onClick={() => onPageChange("next")}
                    >
                      <IoIosArrowForward />
                    </button>
                  </div>
                </div>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default UserDocuments;
